import { render, staticRenderFns } from "./AddJobRequirementDialog.vue?vue&type=template&id=2f606028&scoped=true"
import script from "./AddJobRequirementDialog.vue?vue&type=script&lang=js"
export * from "./AddJobRequirementDialog.vue?vue&type=script&lang=js"
import style0 from "./AddJobRequirementDialog.vue?vue&type=style&index=0&id=2f606028&prod&lang=css"
import style1 from "./AddJobRequirementDialog.vue?vue&type=style&index=1&id=2f606028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f606028",
  null
  
)

export default component.exports